import { render, staticRenderFns } from "./logisticsDetails.vue?vue&type=template&id=7c3f4945&scoped=true&"
import script from "./logisticsDetails.vue?vue&type=script&lang=js&"
export * from "./logisticsDetails.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDetails.vue?vue&type=style&index=0&id=7c3f4945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f4945",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c3f4945')) {
      api.createRecord('7c3f4945', component.options)
    } else {
      api.reload('7c3f4945', component.options)
    }
    module.hot.accept("./logisticsDetails.vue?vue&type=template&id=7c3f4945&scoped=true&", function () {
      api.rerender('7c3f4945', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/logisticsDetails.vue"
export default component.exports